export default "__VITE_ASSET__CrPzUT1M__"